import { render, staticRenderFns } from "./subTable.vue?vue&type=template&id=b196ae58&scoped=true&"
import script from "./subTable.vue?vue&type=script&lang=js&"
export * from "./subTable.vue?vue&type=script&lang=js&"
import style0 from "./subTable.vue?vue&type=style&index=0&id=b196ae58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b196ae58",
  null
  
)

export default component.exports